import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DateUtilService, CommonModalService } from 'gung-common';
import { PdfDownloadIndicatorService } from 'gung-dynamic-pdf';
import { SavedQuoteTableComponent, CartsService, ProductService, CartService, GungModalService, CartExportService, AuthService, SavedQuoteTableService, Cart, gungAddRemoveSpinner, Product } from 'gung-standard';
import { CarLinerMysetupService } from '../../services/car-liner-mysetup.service';
import { first } from 'rxjs';

export const CAR_LINER_FREE_TEXT_PRODUCT_ID = '46607-03';

@Component({
    selector: 'car-liner-saved-quote-table',
    templateUrl: './car-liner-saved-quote-table.component.html',
    styleUrls: ['./car-liner-saved-quote-table.component.scss'],
    standalone: false
})
export class CarLinerSavedQuoteTableComponent extends SavedQuoteTableComponent implements OnInit {

  freeTextProductId = CAR_LINER_FREE_TEXT_PRODUCT_ID;

  mapData: {
    [id: string]: {
      qty: number;
      product: Product;
      productId: string;
      productPartialId?: string;
      extra?: any;
    }[];
  } = {};

  constructor(
    protected translateService: TranslateService,
    protected cartsService: CartsService,
    protected productService: ProductService,
    protected cartService: CartService,
    protected modalService: GungModalService,
    protected cartExportService: CartExportService,
    public dateUtilService: DateUtilService,
    protected authService: AuthService,
    protected pdfDownloadIndicatorService: PdfDownloadIndicatorService,
    protected savedQuoteTableService: SavedQuoteTableService,
    protected commonModalService: CommonModalService,
    protected carLinerMysetupService: CarLinerMysetupService
  ) {
    super(
      translateService,
      cartsService,
      productService,
      cartService,
      modalService,
      dateUtilService,
      savedQuoteTableService
    );
  }

  ngOnInit(): void {
  }

  addUserToCart(cart: Cart, { target }) {
    gungAddRemoveSpinner(target);
    const username = '';
    this.commonModalService.openListManagementModal('ENTER_USERNAME', 'USERNAME', cart.extra.allowedUsername).then(
      (newList) => {
        // if (cart.extra.allowedUsername && Array.isArray(cart.extra.allowedUsername)) {
        //   cart.extra.allowedUsername.push(value);
        // } else {
        //   cart.extra.allowedUsername = [ value ];
        // }
        cart.extra.allowedUsername = newList;
        this.cartsService.updateSavedCart(cart).subscribe({
          next: (v) => gungAddRemoveSpinner(target),
          error: (e) => gungAddRemoveSpinner(target)
        });
      },
      (_) => { gungAddRemoveSpinner(target) }
    ).finally(() => {  })
  }

  protected setMappedData(cartId: string, data: { qty: number; product: Product; productId: string }[]): void {
    if (!this.mapData[cartId]) {
      const cart = this.data?.find(c => c.id === cartId);
      this.mapData[cartId] = data
        .map((row, i) => {
          const cartRow = cart?.data?.rows?.[i];
          return {
            qty: row.qty,
            product: row.product,
            productId: row.productId,
            productPartialId: cartRow?.productPartialId,
            extra: cartRow?.extra
          };
        })
        .filter(row => !!row.product);
    }
  }

  donwloadQuotePDF(cart: Cart): void {
    // Add language from myCompany to saved quote for export
    this.carLinerMysetupService.getMySetup().pipe(first()).subscribe(mySetup => {
      cart.extra.language = mySetup?.extra?.language || '';

      // Keep panel closed
      this.accordion.collapse(cart.id);
      this.savedQuoteTableService.downloadQuotePdf(cart);
    });
  }
}
